export enum FilePreviewStatus {
    SupportedByFileViewer = 'supported_by_file_viewer',
    SupportedByHTMLObject = 'supported_by_html_object',
    Unsupported = 'unsupported',
}
